import React from 'react';
import PartPayments from 'us.collection.partpayments';
import { useNavigate, useLocation } from 'react-router-dom';
import { INavigationData } from 'us.collection/interfaces';

interface ICnt_PartPayments  {
	caseNo: number;
}

const Cnt_PartPayments: React.FC<ICnt_PartPayments> = (props) => {
	const navigate = useNavigate();
	const location = useLocation();
	const state = location.state as INavigationData;
	
	const onMinimize = () => {
		navigate(`/case/${props.caseNo}`, { state });
	};

	return (
		<PartPayments.Components.PartPaymentDetail
			{...props}
			minimize={() => {
				onMinimize();
			}}
		/>
	);
};

export default Cnt_PartPayments;
